// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  fetchGetStuInfoPending: false,
  fetchGetStuInfoError: null,
  fetchGetStuInfoSuccess: null,
  fetchGetMyCoursePending: false,
  fetchGetMyCourseError: null,
  fetchGetMyCourseSuccess: null,
  fetchGetMyCourseTotal: 0,
  fetchGetMyQuestionPending: false,
  fetchGetMyQuestionError: null,
  fetchGetMyQuestionSuccess: null,
  fetchGetNotificationPending: false,
  fetchGetNotificationError: null,
  fetchGetNotificationSuccess: null,
  fetchGetWaitPayPending: false,
  fetchGetWaitPayError: null,
  fetchGetWaitPaySuccess: null,
  fetchGetMyInterlocutionPending: false,
  fetchGetMyInterlocutionError: null,
  fetchGetMyInterlocutionSuccess: null,
  fetchDelMyInterIocutionPending: false,
  fetchDelMyInterIocutionError: null,
  fetchGetMyInterIocutionCountPending: false,
  fetchGetMyInterIocutionCountError: null,
  fetchGetMyInterIocutionCountSuccess: null,
  fetchGetMyCommentPending: false,
  fetchGetMyCommentError: null,
  fetchGetMyCommentSuccess: null,
  fetchGetMyCommentTotal: 0,
  fetchGetMyCollectPending: false,
  fetchGetMyCollectError: null,
  fetchGetIsOrderPending: false,
  fetchGetIsOrderError: null,
  fetchGetIsOrderSuccess: null,
  fetchCancelCollectionPending: false,
  fetchCancelCollectionError: null,
  fetchCancelCollectionSuccess: null,
  fetchGetLookInfoPending: false,
  fetchGetLookInfoError: null,
  fetchGetLookInfoSuccess: null,
  fetchGetAllSubjectPending: false,
  fetchGetAllSubjectError: null,
  fetchGetAllSubjectSuccess: null,
  fetchGetQuestionStorePending: false,
  fetchGetQuestionStoreError: null,
  fetchGetQuestionStoreSuccess: null,
  fetchGetQuestionStoreSelect: null,
  fetchGetChapterPending: false,
  fetchGetChapterError: null,
  fetchGetChapterSuccess: null,
  fetchGetChapterPraticeInfoPending: false,
  fetchGetChapterPraticeInfoError: null,
  fetchGetChapterPraticeInfoSuccess: null,
  fetchGetExamPaperListPending: false,
  fetchGetExamPaperListError: null,
  fetchGetExamPaperListSuccess: null,
  fetchGetExamPaperListTotal: 0,
  fetchAddCollectonPending: false,
  fetchAddCollectonError: null,
  fetchAddCollectonSuccess: null,
  fetchGetStudentPraticeListPending: false,
  fetchGetStudentPraticeListError: null,
  fetchGetStudentPraticeListSuccess: null,
  fetchGetStudentPraticeListTotal: 0,
  fetchGetQuestionTypeListPending: false,
  fetchGetQuestionTypeListError: null,
  fetchGetQuestionTypeListSuccess: null,
  fetchGetCollectionListPending: false,
  fetchGetCollectionListError: null,
  fetchGetCollectionListSuccess: null,
  fetchGetCollectionListTotal: 0,
  fetchGetCollectionExamListPending: false,
  fetchGetCollectionExamListError: null,
  fetchGetCollectionExamListSuccess: null,
  fetchGetCollectionExamListTotal: 0,
  fetchGetMyWrongQuestionPending: false,
  fetchGetMyWrongQuestionError: null,
  fetchGetMyNotePending: false,
  fetchGetMyNoteError: null,
  fetchGetMyNoteSuccess: null,
  fetchGetMyNoteTotal: 0,
  fetchAddQuestionNotePending: false,
  fetchAddQuestionNoteError: null,
  fetchAddQuestionNoteSuccess: null,
  fetchAddQuestionerrorCorrectionPending: false,
  fetchAddQuestionerrorCorrectionError: null,
  fetchAddQuestionerrorCorrectionSuccess: null,
  fetchDeleteNoteByIdPending: false,
  fetchDeleteNoteByIdError: null,
  fetchDeleteNoteByIdSuccess: null,
  fetchGetQuestionerrorCorrectionListPending: false,
  fetchGetQuestionerrorCorrectionListError: null,
  fetchGetQuestionerrorCorrectionListSuccess: null,
  fetchGetQuestionerrorCorrectionListTotal: 0,
  fetchUpdateHeadPicPending: false,
  fetchUpdateHeadPicError: null,
  fetchUpdateHeadPicSuccess: null,
  fetchGetMyOrderPending: false,
  fetchGetMyOrderError: null,
  fetchGetMyOrderSuccess: null,
  fetchGetMyOrderTotal: 0,
  fetchDeleteOrderPending: false,
  fetchDeleteOrderError: null,
  fetchDeleteOrderSuccess: null,
  fetchCancelOrderPending: false,
  fetchCancelOrderError: null,
  fetchCancelOrderSuccess: null,
  fetchRefundPending: false,
  fetchRefundError: null,
  fetchGetNationListPending: false,
  fetchGetNationListError: null,
  fetchGetNationListSuccess: null,
  fetchGetProvincesPending: false,
  fetchGetProvincesError: null,
  fetchGetProvincesSuccess: null,
  fetchGetProvinceListSuccess: null,
  fetchGetHDictionaryListPending: false,
  fetchGetHDictionaryListError: null,
  fetchGetHDictionaryListSuccess: null,
  fetchGetCitysPending: false,
  fetchGetCitysError: null,
  fetchGetDistrictsPending: false,
  fetchGetDistrictsError: null,
  fetchGetDistrictsSuccess: null,
  fetchEditStudentPending: false,
  fetchEditStudentError: null,
  fetchEditStuPwdPending: false,
  fetchEditStuPwdError: null,
  fetchEditStuPwdSuccess: null,
  fetchGetStuInfoCodePending: false,
  fetchGetStuInfoCodeError: null,
  fetchEditStuInfoPhonePending: false,
  fetchEditStuInfoPhoneError: null,
  fetchDeleteMyCorrectionPending: false,
  fetchDeleteMyCorrectionError: null,
  fetchGetMycenterAdPending: false,
  fetchGetMycenterAdError: null,
  fetchGetMycenterAdSuccess: null,
  fetchCheckGuidePending: false,
  fetchCheckGuideError: null,
  fetchCheckGuideSuccess: null,
  fetchGuideCompeltePending: false,
  fetchGuideCompelteError: null,
  fetchNoLoginInputToShopcarPending: false,
  fetchNoLoginInputToShopcarError: null,
  fetchGetProvinceListPending: false,
  fetchGetProvinceListError: null,
  fetchMyCouponListPending: false,
  fetchMyCouponListError: null,
  fetchMyCouponListSuccess: null,
  fetchGetCanUseCouponPending: false,
  fetchGetCanUseCouponError: null,
  OrderCouponSelect: null,
  maxDiscountItem: null,
  fetchGetPublicAccountPending: false,
  fetchGetPublicAccountError: null,
  fetchGetDefaultWxImgPending: false,
  fetchGetDefaultWxImgError: null,
  DefaultWxImg: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/center/redux/initialState.js